export default __webpack_public_path__ + "static/media/references__antoni.b2a38dcd.jpg";